import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { useTranslation } from "react-i18next";
import { z } from "zod";
import { Tables } from "../../../gen/tableNames/tables";
import { Clients } from "../../../lib/clients";

const filterG4MetadataSchema = z.object({
  portfolio_id_equals: z.string().optional(),
  needs_lookthrough_equals: z.string().optional(),
});

export type FilterG4MetadataSchema = z.infer<typeof filterG4MetadataSchema>;

export function FilterG4Metadata() {
  const { t } = useTranslation("tables");

  const fields: Field[] = [
    {
      name: "portfolio_id_equals",
      label: t(`${Tables.G4_METADATA}.searchbox.portfolio_id_equals`),
      type: "input",
    },
    {
      name: "needs_lookthrough_equals",
      label: t(`${Tables.G4_METADATA}.searchbox.needs_lookthrough_equals`),
      type: "select",
      useTranslation: false,
      options: [
        { value: "yes", label: "Yes" },
        { value: "no", label: "No" },
      ],
    },
  ];

  return (
    <FilterTable
      columns={2}
      client={Clients.G4}
      schema={filterG4MetadataSchema}
      tableName={Tables.G4_METADATA}
      fields={fields}
    />
  );
}
